<div class="cc-live-container">
  <div class="cc-live-aside">
    <evrideo-content-control-opertation-room-assets-manager></evrideo-content-control-opertation-room-assets-manager>
  </div>
  <div class="cc-live-main">
    <div class="select-container">
      <mat-form-field style="width: 70px">
        <mat-select [formControl]="gridSizeControl">
          <mat-option *ngFor="let size of gridSizes" [value]="size">
            {{ size }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="grid-container" [ngStyle]="gridStyle">
      <evrideo-content-control-operation-room-player
        class="grid-tile"
        *ngFor="let tile of tiles"
      ></evrideo-content-control-operation-room-player>
    </div>
  </div>
</div>
